const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';


export const paymentService = {
    async createPaymentIntent(price:any, currency: string) {
        console.log(price)
        try {
            const url = `${SERVER_URL}/api/payment-intent`;

            const res = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    amount: price,
                    currency: currency,
                    automatic_payment_methods: {
                        enabled: true,
                    },
                }),
            });

            const data = await res.json();
            return data;
        } catch (error) {
            console.error('Error fetching product prices:', error);
            throw error;
        }
    }
}
